import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoReportsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 151,
	height: 150,
	viewBox: "0 0 151 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ii_10522_61974)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M61.9395 42.6417C61.7496 42.4247 61.4753 42.3002 61.1869 42.3002H41.7397C41.1875 42.3002 40.7397 42.7479 40.7397 43.3002V53.0877C40.7397 53.0877 40.7398 53.0878 40.7398 53.0878C40.7398 53.0878 40.7398 53.0878 40.7398 53.0878V106.7C40.7398 107.252 41.1875 107.7 41.7398 107.7H111.882C112.434 107.7 112.882 107.252 112.882 106.7V52.0651C112.882 51.5128 112.434 51.0651 111.882 51.0651H69.7637C69.4753 51.0651 69.201 50.9406 69.0111 50.7236L61.9395 42.6417Z",
				fill: "url(#paint0_linear_10522_61974)"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.289 57.1331H54.4129C53.063 57.1331 51.8891 58.0282 51.5764 59.3413C50.0949 65.5634 46.5236 81.9342 42.1487 103.329C41.7686 105.188 43.1813 106.932 45.0784 106.934C57.2868 106.949 81.815 107.021 104.002 107.025C105.152 107.026 106.203 106.367 106.688 105.325C112.857 92.0464 113.943 82.6002 118.235 60.7351C118.6 58.8769 117.182 57.1331 115.289 57.1331Z",
			fill: "#E3E3E3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.167 70.2695C101.335 70.053 101.53 69.8178 101.804 69.8106C101.81 69.8104 101.816 69.8103 101.822 69.8103H121.825C122.062 69.8103 122.271 69.9325 122.391 70.1174C122.532 70.3335 122.466 70.6107 122.401 70.86L112.98 106.649C112.915 106.898 112.914 107.176 112.773 107.392C112.653 107.577 112.444 107.699 112.207 107.699H41.414C41.3146 107.699 41.2203 107.677 41.1354 107.639C40.6743 107.429 40.8679 106.792 41.1124 106.349L54.5997 81.8768C54.8441 81.4333 54.9069 80.7961 55.3679 80.5866C55.4528 80.548 55.5472 80.5265 55.6465 80.5265H92.9273C92.9332 80.5265 92.9391 80.5264 92.945 80.5263C93.2188 80.5191 93.4142 80.2838 93.5818 80.0673L101.167 70.2695Z",
			fill: "#D6D6D6"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_ii_10522_61974",
			x: 40.7397,
			y: 42.3002,
			width: 72.1421,
			height: 69.3996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0666667 0 0 0 0 0.0627451 0 0 0 0 0.0588235 0 0 0 0.14 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_10522_61974"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 9.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0666667 0 0 0 0 0.0627451 0 0 0 0 0.0588235 0 0 0 0.14 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_10522_61974",
					result: "effect2_innerShadow_10522_61974"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10522_61974",
			x1: 95.2142,
			y1: 36.2165,
			x2: 71.7453,
			y2: 114.837,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .413549,
				stopColor: "#C7C7C7"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#7E7E7E"
			})]
		})] })
	]
});
export default SvgNoReportsIcon;
